import '../scss/collection.scss';
import { sortByChecked } from '../components/sort-by';
import { toggleDataActive } from '../utils/toggle-dataset';
import { mediaQuery } from '../utils/media-query';
import { rangeFilters } from '../components/filters-range';
import { filterCollection } from '../components/filter';
import { focusMenu } from '../components/collection-seo.js';
import { $Q, $Qll } from 'graditify-utils';

sortByChecked();
rangeFilters();

function handleTabitemsFilter(status) {
  const inputsRadio = $Qll('.form__radio-button') || [];
  const inputsCheckbox = $Qll('.form__checkbox') || [];
  const filterItems = [...inputsCheckbox, ...inputsRadio];

  if (status) {
    filterItems.forEach((item) => {
      item.setAttribute('tabindex', '0');
      item.querySelector('input').setAttribute('tabindex', '0');
    });
  } else {
    filterItems.forEach((item) => {
      item.setAttribute('tabindex', '-1');
      item.querySelector('input').setAttribute('tabindex', '-1');
    });
  }
}

toggleDataActive('#filter-open', '#filter', {
  cb: (status) => {
    const filterList = $Q('#list-products');
    const displayGrid = $Q('#js-collection-display');
    const buttonSubmit = $Q('.filter-form__submit.desktop');
    const filterButton = $Q('#filter-open');

    if (!filterList || !displayGrid || !buttonSubmit) return;

    filterList.dataset.active = status;
    displayGrid.dataset.active = status;
    buttonSubmit.setAttribute('data-active', status);

    if (filterButton) filterButton.dataset.active = status;

    mediaQuery('(min-width: 768px)', () => {
      focusMenu(status);
    });
    handleTabitemsFilter(status);
  },
  closeEsc: true,
});

mediaQuery('(max-width: 767px)', () => {
  toggleDataActive('.js-close-filters', '#filter', {
    cb: (status) => {
      const filterButton = $Q('#filter-open');
      if (filterButton) filterButton.dataset.active = status;
    },
  });
});

filterCollection();

toggleDataActive('#js-text-seo-voir-plus', '#js-text-seo-hidden', {
  cb: (status) => {
    const btn = $Q('#js-text-seo-voir-plus');

    if (btn) btn.dataset.active = status;
  },
});
